import { useCallback, useEffect, useRef, useState } from 'react';

const useStateWhenMounted = <T>(
  initialValue?: T
): [T | undefined, (v: T) => void] => {
  const [state, setState] = useState(initialValue);
  const isMounted = useRef(true);
  useEffect(() => {
    return () => {
      isMounted.current = false;
    };
  }, []);

  const setNewState = useCallback((value: T): void => {
    if (isMounted.current) {
      setState(value);
    }
  }, []);

  return [state, setNewState];
};

export default useStateWhenMounted;
